import { box } from 'fc-styles/src/shadow'
import { primary, lightGrey2, lightGrey } from 'fc-styles/src/colors'
import { flex } from 'fc-styles/src/flex'

export const defaultWrapperStyle = ({
  flex: '1 1 auto',
  display: 'flex',
  backgroundColor: '#fff',
  fontSize: 12,
  width: '100%',
})

export const defaultTableStyle = ({
  flex: '1 1 auto',
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'hidden',
})

export const bodyStyle = ({
  flex: '1 1 auto',
  overflowY: 'auto',
  lineHeight: '1.5em',
})

export const bodyDetailedStyle = ({
  ...bodyStyle,
  display: 'flex',
  overflowX: 'hidden',
})

export const barStyle = ({
  display: 'flex',
  alignItems: 'center',
  padding: '5px 7px',
  minHeight: 50,
  backgroundColor: primary(0.2),
})

export const rowStyle = ({
  display: 'flex',
  minHeight: 40,
  transition: 'background-color 0.2s ease-in-out',
  willChange: 'background-color',
})

export const cellStyle = ({
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
})

export const headerStyle = ({
  position: 'relative',
  display: 'flex',
  flex: '0 0 auto',
  boxShadow: '0 2px 2px rgba(0,0,0,0.1)',
  minHeight: 50,
})

export const filtersStyle = ({
  position: 'relative',
  display: 'flex',
  flex: '0 0 auto',
  height: 30,
  borderTop: `1px solid ${lightGrey2()}`,
  borderBottom: `1px solid ${lightGrey2()}`,
  backgroundColor: 'rgba(197, 197, 197, 0.2)',
})

export const headerCellStyle = ({
  ...cellStyle,
  display: 'flex',
  alignItems: 'center',
  fontWeight: 500,
})

export const checkboxStyle = ({
  cursor: 'pointer',
  flex: '0 0 30px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const dataRowStyle = ({
  display: 'flex',
  flex: '1 1 auto',
})

export const recordDetailLabelStyle = ({
  fontWeight: 500,
  paddingBottom: 5,
  borderBottom: '1px solid #ccc',
  textTransform: 'uppercase',
  marginBottom: 10,
  fontSize: 12,
  color: lightGrey(0.8),
})

export const footerStyle = ({
  display: 'flex',
  flex: '0 0 auto',
})

export const paginatorStyle = (flex({
  flex: '1 1 auto',
  position: 'relative',
  alignItems: 'center',
  justifyContent: 'space-around',
  minHeight: 54,
  ...box({x: 0, y: -2, blur: 2, color: 0.1}),
}))
